<script setup lang="ts">
const props = defineProps<{
  data: Page,
}>()
</script>

<template>
  <div>
    <template
      v-if="data?.content?.length"
    >
      <shared-block
        v-for="block in data.content"
        :key="block.id"
        :block="block"
      />
    </template>
  </div>
</template>
